import React from "react";
import { IdCard } from "lucide-react";
import { chipClass } from "./geotabFormat.js";
import { Hint } from "./GeotabHover.jsx";

// Pastille de taille fixe : même place et même taille d'un camion à l'autre. L'explication s'affiche en hovercard.
// Session Geotab à un autre nom, non réglée au relevé : chauffeur à confirmer (même carte que la liste de la Consolidation).
export const DriverCard = () => <IdCard role="img" aria-label="Chauffeur à confirmer" size={13} strokeWidth={2.25} className="inline align-[-2.5px]" />;

export default function GeotabBadge({ tone = "mute", title, children, className = "" }) {
  if (tone === "empty") {
    return <span className="block h-[17px] text-center text-[10.5px] leading-[17px] text-slate-300" aria-hidden="true">—</span>;
  }
  return (
    <Hint text={title}>
      <span className={`block h-[17px] overflow-hidden whitespace-nowrap rounded-[3px] px-[3px] text-center text-[10.5px] font-bold leading-[17px] tabular-nums ${chipClass(tone)} ${className}`}>
        {children}
      </span>
    </Hint>
  );
}
